import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import {
  ForEachModel,
  Model,
  useValue,
  ValueToCollection,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import * as UI from 'ui'
import * as Filters from 'support/filters'
import { TrackCard, TrackCardRow, TrackCardRows, TrackCardTitle } from 'ui/time-tracking'

export default function PersonalShiftsInPeriod (props) {
  const salaryPeriodId = useValue('id')

  if (!salaryPeriodId) {
    return null
  }

  return (
    <Model resourceName='toggle.toggle' operationName='index'>
      <Filters.StaticFilter name='salary_period_id' value={salaryPeriodId} />
      <ValueToCollection name='collection'>
        <WhenCollectionIsNotEmpty>
          <UI.CardHeader>
            <UI.SecondaryHeading>
              <Translation name='sections.shifts_in_period.title' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <UI.CardGroup>
            <ForEachModel>
              <TrackCard>
                <TrackCardTitle />
                <TrackCardRows>
                  <ValueToCollection name='collection'>
                    <ForEachModel>
                      <TrackCardRow />
                    </ForEachModel>
                  </ValueToCollection>
                </TrackCardRows>
              </TrackCard>
            </ForEachModel>
          </UI.CardGroup>
        </WhenCollectionIsNotEmpty>
      </ValueToCollection>
    </Model>
  )
}
